export default __webpack_public_path__ + "static/85379d227370de9d01ed2a2f9194473f.jpg";